import {Component, OnInit, OnDestroy} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-report-cit-apps',
  templateUrl: './report-cit-apps.component.html',
  styleUrls: ['./report-cit-apps.component.css']
})

export class ReportCitAppsComponent implements OnInit, OnDestroy {
  private notifier: NotifierService;
  respObject: any;
  private clientId: number;
  userName: string;
  private userAuth: Subscription;
  private ticketTypeSubscription: Subscription;
  ticketTypeId: number;
  userGroups: any;
  userGroupId: number;
  groupName: string;
  private storage: any;
  types = [];
  reportFileName: string;
  reportLink: string;
  reportFiles = [];
  reportUrl: string;
  reportLoaded: boolean;
  reportType: number;
  seq: number;
  allStatus = [];
  statusSelected = [];
  ticketTypeSelected: number;
  priorities = [];
  prioritySelected = [];
  userGroupSelected = [];
  islead: boolean;
  private baseCategories = [];
  categoryLoaded = false;
  allTicketTypes = [];
  cat = [];
  dynamicFields = [];
  priorityType: number;
  priority: string;
  priorityId: number;
  fromDate: any;
  toDate: any;
  selectedDateType: number;
  dateType = [];
  categoryFilter: string;
  allStatusSelected = new FormControl();
  allPrioritySelected = new FormControl();
  allGroupSelected = new FormControl();
  hideDate: boolean;
  isCategory: boolean;
  private disabledCount: number;


  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
  }

  ngOnInit() {
    this.isCategory = false;
    this.hideDate = true;
    this.islead = false;
    this.reportLoaded = true;
    this.fromDate = '';
    this.toDate = '';
    this.reportType = 7;                 // 1=WIP report, 2=Temp report, 7=multi value report
    this.reportUrl = this.messageService.REPORT_PATH;

    this.ticketTypeId = 0;
    this.selectedDateType = 0;

    this.statusSelected = [];
    this.prioritySelected = [];
    this.userGroupSelected = [];
    this.categoryFilter = '';

    this.dateType = [{id: 1, name: 'Created Date'}, {id: 2, name: 'Modified Date'},
      {id: 3, name: 'Resolution Date'}];

    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.userGroups = this.messageService.groupId;
      this.userName = this.messageService.loginName;
      if (this.messageService.getSupportGroup() === null) {
        this.userGroupId = this.userGroups[0].groupId;
        this.groupName = this.userGroups[0].grpName;
      } else {
        const group = this.messageService.getSupportGroup();
        this.userGroupId = group.groupId;
        this.groupName = group.grpName;
      }
      this.userGroupSelected.push(this.userGroupId);
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.clientId = auth[0].clientId;
        this.userGroups = auth[0].groupId;
        this.userName = auth[0].login_name;
        if (this.messageService.getSupportGroup() === null) {
          this.userGroupId = this.userGroups[0].groupId;
          this.groupName = this.userGroups[0].grpName;
        } else {
          const group = this.messageService.getSupportGroup();
          this.userGroupId = group.groupId;
          this.groupName = group.grpName;
        }
        this.userGroupSelected.push(this.userGroupId);
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
    this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.storage = JSON.parse(localStorage.getItem('dd'));
        this.types = this.respObject.details;
        if (this.storage === null) {
          this.ticketTypeId = this.types[0].id;
          this.seq = this.types[0].seq;
        } else {
          const type = this.storage.type;
          this.types[0].checked = false;
          for (let i = 0; i < this.types.length; i++) {
            // console.log(this.types[i].id, type);
            if (this.types[i].id === type) {
              this.ticketTypeId = this.types[i].id;
              this.types[i].checked = true;
              this.seq = this.types[i].seq;
              this.types[i].checked = true;
              break;
            }
          }
          // console.log('seq---------> : ' + this.seq);
        }
        if (this.seq === 1) {
          this.ticketTypeSelected = 0;
        } else if (this.seq === 2) {
          this.ticketTypeSelected = 1;
        }
        this.getStatus(this.seq);
        this.getPriority();
        this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
          this.respObject = res3;
          if (this.respObject.success) {
            this.islead = this.respObject.details[0].is_spoc;
            this.getTicketLoadingDataWithAttr();
          }
        });
      }
    });
    this.getReportList();
  }

  getStatus(sequence) {
    this._rest.getStatusByTicketTypeLt(sequence, this.clientId).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        // this.respObject.details.unshift({id: 0, status: 'Select Ticket Status'});
        this.allStatus = this.respObject.details;
        // this.statusSelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

  getPriority() {
    this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketTypeId).subscribe((res2) => {
      this.respObject = res2;
      if (this.respObject.success) {
        // this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
        this.priorities = this.respObject.details;
        // this.prioritySelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.respObject.errorMessage);
    });
  }


  getTicketLoadingDataWithAttr() {
    this._rest.getTicketCreateLoadingDtlsWithGroup(this.messageService.getUserId(), this.ticketTypeId,
        this.clientId, this.userGroupSelected).subscribe((res) => {
      this.respObject = res;
      this.categoryLoaded = true;
      if (this.respObject.success) {
        // console.log('=================>' + JSON.stringify(this.respObject));
        this.isCategory = true;
        // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
        this.baseCategories = this.messageService.copyArray(this.respObject.details.arr);
        this.allTicketTypes = this.respObject.details.arr;
        this.disabledCount = this.respObject.details.count;
        // this.priorityType = this.respObject.details[0].val.type;
        this.cat = [];
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }



  onCategoryChange(ticket, option) {
    // console.log(JSON.stringify(option), typeof option, ticket.id);
    // if(this.ticketTypes)

    const opt = JSON.parse(option);
    if (opt.type !== 'header') {
      // if (this.attachment.length > 0) {
      //   this.attachment = [];
      // }
      const value = opt.id;
      let matched = false;
      const index = this.allTicketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      // console.log('index:' + index, this.disabledCount);
      // console.log(typeof this.disabledCount, typeof index);
      const index1 = this.allTicketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id);
      const pid = this.allTicketTypes[index1].options[0].id;
      // // console.log(this.allTicketTypes[index1].options[0]);
      // console.log(index1);
      if (index1 === this.disabledCount ) {
        // console.log('inside index'+this.cat.length);
        if (this.cat.length === 0) {
          let pid1, cid1;
          for (let i = 0; i < this.disabledCount ; i++) {
            pid1 = this.baseCategories[i].options[1].id;
            cid1 = this.baseCategories[i].options[0].id;
            this.cat.push({pid: pid1, cid: cid1});
          }
        }

      }
      if (this.cat.length === 0) {
        this.cat.push({pid: pid, cid: value});
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.cat.push({pid: pid, cid: value});
        } else {
          for (let i = index; i < this.cat.length; i++) {
            // // console.log('matched');
            // // console.log(this.cat[i]);
            if (index > -1) {
              this.cat[i].cid = 0;
            }
          }
        }
      }
      // console.log(JSON.stringify(this.cat));
      // clear sub categories
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.allTicketTypes.length; i++) {
          const options = this.allTicketTypes[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.allTicketTypes[i].options = [options[j]];
              break;
            }
          }
        }
      }

      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;
        // console.log('+++++++++++++++++++++++++++' + JSON.stringify(this.ticketTypes));
        let data;
        if (index > -1) {
          data = this.allTicketTypes[index].options[0];
        }
        if (this.respObject.success) {
          // data = this.ticketTypes[index].options[0];
          this.respObject.details.unshift(data);
          this.allTicketTypes[index].options = this.respObject.details;
          // console.log('+++++++++++++++++++++++++++' + JSON.stringify(this.ticketTypes[index].options));
        } else {
          if (index > -1) {
            this.allTicketTypes[index].options = [data];
          }
          // this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  onSelectTicketType(selectedIndex) {
    this.ticketTypeId = this.types[selectedIndex].id;
    this.seq = this.types[selectedIndex].seq;
    this.getStatus(this.seq);
    this.getPriority();
    this.getTicketLoadingDataWithAttr();
  }

  onSelectDateType(selectedIndex) {
    this.hideDate = false;
  }

  selectAllStatus(ev , value) {
    if (ev._selected) {
      const array = [];
      for (let l = 0 ; l < value.length ; l++ ) {
        array.push(value[l].id);
      }
      this.allStatusSelected.setValue(array);
      ev._selected = true;
    }
    if (ev._selected === false) {
      this.statusSelected = [];
      this.allStatusSelected.setValue([]);
    }

  }

  selectAllPriority(ev , value) {
    if (ev._selected) {
      const array = [];
      for (let l = 0 ; l < value.length ; l++ ) {
        array.push(value[l].id);
      }
      this.allPrioritySelected.setValue(array);
      ev._selected = true;
    }
    if (ev._selected === false) {
      this.prioritySelected = [];
      this.allPrioritySelected.setValue([]);
    }

  }

  // selectAllGroup(ev , value) {
  //     if (ev._selected) {
  //         const array = [];
  //         for (let l = 0 ; l < value.length ; l++ ) {
  //             array.push(value[l].groupId);
  //         }
  //         this.allGroupSelected.setValue(array);
  //         ev._selected = true;
  //     }
  //     if (ev._selected === false) {
  //         this.userGroupSelected = [];
  //         this.allGroupSelected.setValue([]);
  //     }
  //
  // }



  getReportList() {
    this.reportLoaded = false;
    this._rest.getSscReportList(this.clientId, this.reportType).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.reportLoaded = true;
        for (let i = 0; i < this.respObject.details.length; i++) {
          this.respObject.details[i].createdate =
              this.messageService.datePipeFunc(this.respObject.details[i].createdate);
        }
        this.reportFiles = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      // console.log('err==', err);
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  generate() {
    let date1 = new Date(this.fromDate).valueOf();
    let date2 = new Date(this.toDate).valueOf();
    let diffTime = Math.abs(date2 - date1);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 


    let isError = false;
    // let cats;
    // console.log('this.cat.length====' + JSON.stringify(this.cat));
    if (this.cat.length > 0) {
      this.categoryFilter = '';
    }

    for (let i = 0; i < this.cat.length; i++) {
      if (this.cat[i].cid !== 0) {
        // console.log('this.cat===' + JSON.stringify(this.cat[i]));
        this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
        if (i !== this.cat.length - 1) {
          this.categoryFilter += ',';
        }
      } else {
        isError = true;
        break;
      }
    }

    const lastChar = this.categoryFilter.substr(-1);
    if (lastChar === ',') {
      this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
    }


    if (this.categoryFilter === '') {
      this.categoryFilter = '0';
    }
    const data = {
      ticketTypeId : this.ticketTypeId,
      dateType : this.selectedDateType,
      fromDate : this.messageService.ticketConverter(this.fromDate, 1),
      toDate : this.messageService.ticketConverter(this.toDate, 1),
      status : this.statusSelected,
      priority: this.prioritySelected,
      catFilterLt: this.categoryFilter,
      client_id: this.clientId
    };
    if(Number(diffDays)  <= 31){

    this._rest.generateCitAppsReport(data).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.notifier.notify('success', this.messageService.REPORT_SUCCESS);
        this.selectedDateType = 0;
        this.statusSelected = [];
        this.prioritySelected = [];
        this.hideDate = true;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', err);
    });
  }else{
    this.notifier.notify('error', this.messageService.REPORT_TIME);

}

  }

  changeRouting() {
    if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
      this.messageService.changeRouting(this.messageService.dashboardUrl);
    }
  }

  download() {
  }

  ngOnDestroy() {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }

    if (this.ticketTypeSubscription) {
      this.ticketTypeSubscription.unsubscribe();
    }
  }
  downloadFile(attachedFilePath: any) {
    this._rest.downloadFile(this.clientId, attachedFilePath, 'report').subscribe((res: any) => {
      if (res.success) {
        window.location.href = res.value;
      } else {
        alert(res.errorMessage);
      }
    }, (err) => {
    });
  }
}
